export default {"src":"/_next/static/media/shopping-cart.ecae598e.svg","height":65,"width":71,"blurWidth":0,"blurHeight":0};